import { useState } from "preact/hooks";
import type { Strings } from "../state.js";

export interface TextInputProps {
  enabled: boolean;
  strings: Strings;
  onSend(text: string): void | Promise<void>;
}

export function TextInput({ enabled, strings, onSend }: TextInputProps) {
  const [value, setValue] = useState("");
  const [sending, setSending] = useState(false);
  const sendable = enabled && !sending && value.trim().length > 0;

  return (
    <form
      class="va-text-input"
      onSubmit={async (event) => {
        event.preventDefault();
        if (!sendable) return;
        setSending(true);
        try {
          await onSend(value.trim());
          setValue("");
        } catch {
          // Preserve the draft so the user can retry. The integration may report
          // transport errors through its own callback/telemetry surface.
        } finally {
          setSending(false);
        }
      }}
    >
      <input
        type="text"
        dir={value ? "auto" : undefined}
        value={value}
        maxLength={4000}
        disabled={!enabled || sending}
        aria-label={strings.textInputPlaceholder}
        placeholder={strings.textInputPlaceholder}
        onInput={(event) => setValue(event.currentTarget.value)}
      />
      <button type="submit" disabled={!sendable}>
        {strings.sendMessage}
      </button>
    </form>
  );
}
